import { Box, Typography } from "@mui/material";

function DashboardIndex(props: any) {

  return (
    <Box sx={{margin: 20 }} display="flex" flexDirection="column" alignContent="stretch">
      <Typography variant="h5" mb={10}>Dashboard</Typography>
    </Box>
  );
}

export default DashboardIndex;